export const rateLockDaysLabel = (rateLockDays: number | null) => {
  return rateLockDays === null ? 'Unknown' : `${rateLockDays} day${rateLockDays !== 1 ? 's' : ''}`;
};
